module.exports = __webpack_public_path__ + "img/banker-gold-page_1248.cab90eb3.png";